import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { request, METHOD } from '@/utils/request';
export function getDictCategory(_x) {
  return _getDictCategory.apply(this, arguments);
}
function _getDictCategory() {
  _getDictCategory = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(data) {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          return _context.a(2, request("/basic/getDictCategory", METHOD.POST, data));
      }
    }, _callee);
  }));
  return _getDictCategory.apply(this, arguments);
}
export function getDictFixInfo(_x2) {
  return _getDictFixInfo.apply(this, arguments);
}
function _getDictFixInfo() {
  _getDictFixInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(data) {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          return _context2.a(2, request("/basic/getDictFixInfo", METHOD.POST, data));
      }
    }, _callee2);
  }));
  return _getDictFixInfo.apply(this, arguments);
}
export function addDictFixInfo(_x3) {
  return _addDictFixInfo.apply(this, arguments);
}
function _addDictFixInfo() {
  _addDictFixInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(data) {
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          return _context3.a(2, request("/basic/addDictFixInfo", METHOD.POST, data));
      }
    }, _callee3);
  }));
  return _addDictFixInfo.apply(this, arguments);
}
export function editDictFixInfo(_x4) {
  return _editDictFixInfo.apply(this, arguments);
}
function _editDictFixInfo() {
  _editDictFixInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(data) {
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          return _context4.a(2, request("/basic/editDictFixInfo", METHOD.POST, data));
      }
    }, _callee4);
  }));
  return _editDictFixInfo.apply(this, arguments);
}
export function getFirstDictFixInfo(_x5) {
  return _getFirstDictFixInfo.apply(this, arguments);
}
function _getFirstDictFixInfo() {
  _getFirstDictFixInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(id) {
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          return _context5.a(2, request("/basic/getFirstDictFixInfo", METHOD.POST, {
            id: id
          }));
      }
    }, _callee5);
  }));
  return _getFirstDictFixInfo.apply(this, arguments);
}